export default function LiveKaraoke() {
  const features = [
    {
      icon: 'ri-mic-line',
      title: 'Open Mic Every Night',
      description: 'Take the stage and showcase your talent with our extensive song library featuring over 1,000 tracks in multiple languages. Professional sound system and lighting create the perfect performance atmosphere.',
      gradient: 'from-purple-500 to-purple-700'
    },
    {
      icon: 'ri-door-lock-line',
      title: 'VIP Room Experience',
      description: 'Book our private karaoke rooms for an intimate experience. Each room features premium sound systems, comfortable seating, and personalized service. Perfect for parties and celebrations.',
      gradient: 'from-blue-500 to-blue-700'
    },
    {
      icon: 'ri-music-2-line',
      title: 'Weekend DJ Sets',
      description: 'Friday and Saturday nights feature live DJ performances mixing the hottest tracks. Dance, sing, and enjoy the ultimate nightlife experience with our resident DJs.',
      gradient: 'from-pink-500 to-pink-700'
    }
  ];

  return (
    <section id="live-karaoke" className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-8">
          <div>
            <h2 className="text-6xl font-bold text-white leading-tight">
              Live<br />Entertainment
            </h2>
          </div>
          <div className="max-w-xl">
            <p className="text-xl text-gray-300 leading-relaxed">
              Experience nightly performances, open mic opportunities, and special entertainment events. Every night brings new energy and unforgettable moments.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-gradient-to-br ${feature.gradient} rounded-3xl p-8 hover:scale-105 transition-all duration-300 shadow-xl hover:shadow-2xl`}
            >
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{feature.title}</h3>
              <p className="text-base text-white/90 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-pink-600 to-purple-600 rounded-3xl p-12 text-center">
          <h3 className="text-4xl font-bold text-white mb-4">Special Events &amp; Parties</h3>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
            Host your birthday, corporate event, or celebration with us. We offer customizable packages, dedicated service, and an unforgettable experience for groups of all sizes.
          </p>
          <button className="bg-white text-pink-600 px-10 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all hover:scale-105 shadow-xl whitespace-nowrap">
            Inquire About Events
          </button>
        </div>
      </div>
    </section>
  );
}
